/** Normalize city/region for reliable matching (handles spacing/case). */
export const normalizeCity = (s) => String(s ?? "").trim().toLowerCase();

export const productTypeOf = (p) => {
  const t = String(p?.product_type ?? "league").trim().toLowerCase();
  return t === "tournament" ? "tournament" : "league";
};

/** Age groups that don't form their own division (the division int decides instead). */
const GENERIC_AGE_GROUPS = new Set(["adult", "youth"]);

/**
 * Stable division label for a product row — must match SelectDivision / DB semantics.
 * Do not map unknown division ints to "DIV 1" (that hid YOUTH / extra programs).
 * Optional 3rd arg: product row or product_type string ('league' | 'tournament').
 */
export const divisionLabelForProduct = (city, divisionInt, productOrType) => {
  const product =
    typeof productOrType === "object" && productOrType != null ? productOrType : null;
  const type = product
    ? productTypeOf(product)
    : String(productOrType ?? "").trim().toLowerCase();
  if (type === "tournament") return "Tournament";

  // league_teams / deep links may already store display labels
  if (typeof divisionInt === "string") {
    const s = divisionInt.trim();
    if (s && !Number.isFinite(Number(s))) return s;
  }

  // A named age group (e.g. "35+") is its own division; its fixtures, teams and
  // players are filed under that label rather than a DIV number.
  const ageGroup = String(product?.age_group ?? "").trim();
  if (ageGroup && !GENERIC_AGE_GROUPS.has(ageGroup.toLowerCase())) return ageGroup;

  if (city === "Mississauga") return "League";
  const n = Number(divisionInt);
  if (!Number.isFinite(n)) return "League";
  if (city === "Cambridge") {
    if (n === 2) return "DIV 2";
    if (n === 1) return "DIV 1";
    if (n === 10) return "Tournament";
    return `DIV ${n}`;
  }
  return `DIV ${n}`;
};

export const uniqueDivisionLabelsForCity = (region, productsInCity) => {
  const set = new Set();
  for (const p of productsInCity || []) {
    set.add(divisionLabelForProduct(region, p.division, p));
  }
  return [...set].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
};
